
export const pagAdmin = 'pagAdmin'

export const pagPrincipal = 'pagPrincipal'


export const empresa = 'empresa'
export const productos = 'productos'
export const descargas = 'descargas'